import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navigation from "@/components/Navigation";
import FooterMinimal from "@/components/FooterMinimal";

const BookThankYou = () => {
  useEffect(() => {
    document.title = "Thank you | Astreon AI Group";
    if (typeof window !== "undefined" && typeof (window as any).gtag === "function") {
      (window as any).gtag("event", "strategy_session_booked", {
        event_category: "lead",
        event_label: "Calendly strategy session",
      });
    }
    if (typeof window !== "undefined") {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({ event: "strategy_session_booked" });
    }
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Navigation />
      <section className="flex-1 flex items-center justify-center px-6 pt-[58px] pb-20">
        <div className="max-w-2xl text-center">
          <p className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground mb-6">
            Astreon AI Group
          </p>
          <h1 className="text-[42px] sm:text-[56px] md:text-[64px] leading-[1.05] tracking-[-0.02em] font-normal mb-6">
            Thank you.
          </h1>
          <p className="text-[16px] sm:text-[18px] text-muted-foreground leading-relaxed mb-10 max-w-xl mx-auto">
            Your strategy session is confirmed. You'll receive a calendar invite and confirmation email shortly with all the details. We look forward to speaking with you.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-full border border-foreground text-foreground px-7 py-3 text-[14px] font-medium hover:bg-foreground hover:text-background transition-colours"
            >
              Back to home
            </Link>
            <Link
              to="/blog"
              className="inline-flex items-center justify-center rounded-full bg-foreground text-background px-7 py-3 text-[14px] font-medium hover:opacity-90 transition-opacity"
            >
              Read our latest thinking
            </Link>
          </div>
        </div>
      </section>
      <FooterMinimal />
    </div>
  );
};

export default BookThankYou;
